/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cas_Visibility_Enabled_DescriptionInputs */

const en_cas_visibility_enabled_description = /** @type {(inputs: Cas_Visibility_Enabled_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capital Account Statements are now visible on every customer’s portal`)
};

/**
* | output |
* | --- |
* | "Capital Account Statements are now visible on every customer’s portal" |
*
* @param {Cas_Visibility_Enabled_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cas_visibility_enabled_description = /** @type {((inputs?: Cas_Visibility_Enabled_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cas_Visibility_Enabled_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cas_visibility_enabled_description(inputs)
});